import React from 'react';
import { Box } from '@chakra-ui/react';
import Header from '../../components/provider/header';
import Sidebar from '../../components/global/sideBar';
import JobManagementTable from '../../components/provider/jobListTable'; // Import the JobManagementTable component

const JobManagementPage = () => {
  return (
    <Box display="flex" minH="100vh">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <Box flex="1" ml="250px" pt="60px" p={4}> {/* Adjust ml to match Sidebar width */}
        {/* Header */}
        <Box position="fixed" top="0" left="250.8px" right="0" zIndex="1000">
          <Header />
        </Box>

        {/* Job Management Table */}
        <Box mt={12}>
          <JobManagementTable /> {/* Include the JobManagementTable component here */}
        </Box>
      </Box>
    </Box>
  );
};

export default JobManagementPage;